export const helpOptions = ['helpIsNeeded', 'noHelpNeeded'];

export const userTypeOptions = ['student', 'parent'];

// const subjectOptions = [
//   'Geography',
//   'Mathematics',
//   'PrimaryEducation',
//   'SpeechTherapy',
//   'Physics',
//   'OtherLanguages',
//   'Lithuanian',
//   'InformationTechnologies',
//   'History',
//   'English',
//   'Biology',
//   'Chemistry',
//   'CarrierMentor',
// ];

// async function initializeSubjectOptions() {
//   try {
//     return await subjectsRepository.fetchSubjects();
//   } catch (error) {
//     console.error('Error fetching subjects:', error);
//     // Handle error if needed
//   }
// }

// // initializeSubjectOptions();

const grades = [];
for (let i = 1; i <= 12; i++) {
  grades.push(i);
}
export const gradesOptions = [...grades, 'Student', 'Adult'];

export const goalOptions = [
  'knowledge_gaps',
  'enhance_current_level',
  'for_exams',
  'other',
];
export const whereDidYouHearOptions = {
  title: 'channel',
  answers: [
    'google',
    'social_network',
    'influencers',
    'friend_recommendation',
    'other',
  ],
};

export const surveyQuestions = [
  {
    question: 'chooseTeacher',
    options: helpOptions,
    answersType: 'button',
  },
  {
    question: 'user_type',
    options: userTypeOptions,
    answersType: 'button',
  },
  {
    question: 'nameAndDiscount',
    options: [
      {
        title: 'name',
        type: 'text',
        required: true,
      },
      { title: 'email', type: 'email', required: true },
      { title: 'discount_code', type: 'text', required: false },
    ],
    answersType: 'input',
  },
  {
    question: 'subject',
    options: null,
    answersType: 'button',
  },
  {
    question: 'grade',
    options: gradesOptions,
    answersType: 'button',
  },
  {
    question: 'topic',
    options: goalOptions,
    answersType: 'button',
  },
  {
    question: [
      {
        question: 'contacts',
        options: [{ title: 'phone_number', type: 'phone', required: true }],
        answersType: 'input',
      },
      {
        question: 'howDidYouHear',
        options: whereDidYouHearOptions,
        answersType: 'select',
      },
    ],
  },
];

export const surveyInfoTexts = [
  'firstMessage',
  'secondMessage',
  'thirdMessage',
  'fourthMessage',
  'fifthMessage',
  'sixthMessage',
  '',
];

export const surveyImages = [
  // 'image0',
  // 'image1',
  // 'image2',
  '../../../src/assets/survey/image3.jpg',
  // '../../../src/assets/survey/image4.jpg',
  // '../../../src/assets/survey/image5.jpg',
  // '../../../src/assets/survey/image6.jpg',
];
